import { stringify } from 'qs';
import {URL_API} from "../../url.config";
import {request} from "../../utils/apiUtils";
let YearController = {
    getListYear: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    searchByType: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/search-by-type?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },

    getDetail: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/detail/${payload.id}`,
            method: 'GET',
        }, callback)
    },
    block: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/block/${payload.id}`,
            method: 'GET'
        }, callback)
    },
    unblock: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-core/ad-sas-school/program/unblock/${payload.id}`,
            method: 'GET'
        }, callback)
    },
    delete: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/year/delete/${payload.id}`,
            method: 'GET'
        }, callback)
    },
}
export default YearController
